/*eslint-disable array-callback-return */
/*eslint-disable no-unused-vars */
import React, { useState } from 'react';
import MasterPermissions from '../../../../api/MasterPermissions';
import { Row, Col, Nav, Form, InputGroup } from 'react-bootstrap';
import { SearchSVG } from '../../../../img/GlobalSVG';
import TextInput from '../../../common/text-input';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
import { DownloadDropdown } from '../../../common/downloadFiles';
import Feature from '../../../../../../src/services/feature';
import {
  AccountsPDFEmailBody,
  AccountsCSVEmailBody,
} from '../../../../configuration/EmailData';
import { TABLE_HEADER } from '../../../../../constants/index';
import { ToastContainer, toast } from 'react-toastify';

const AccountDetailsFilter = ({
  filterByClaimNumber,
  filterByTransactionType,
  resetFilter,
  data: csvData,
}) => {
  const [searchString, setSearchString] = useState('');
  const [activeDescriptions, setActiveDescriptions] = useState([]);
  const csvDetailedInfo = [];
  csvData.forEach((csvInfo) => {
    const { TrxIndex, ClaimOid, ...requiredCsvInfo } = csvInfo;
    csvDetailedInfo.push(requiredCsvInfo);
  });

  let shareTxns = false;
  let downloadtxns = false;
  let searchTxns = false;

  if (MasterPermissions.CheckPermission('Download Transactions'))
    downloadtxns = true;

  if (MasterPermissions.CheckPermission('Share Transactions')) shareTxns = true;

  if (MasterPermissions.CheckPermission('Search Transactions'))
    searchTxns = true;

  const frameDataForCSV = (csvData) => {
    const csvDetailedInfo = [];
    if (csvData?.length > 0) {
      csvData.forEach((csvInfo) => {
        const { Claimnumber, Action, ...requiredCsvInfo } = csvInfo;
        csvDetailedInfo.push(requiredCsvInfo);
      });
      return csvDetailedInfo;
    }
  };
  const claimSearchHandlr = (event) => {
    const searchTerm = event.target.value.replace(/  +/g, ' ');
    setSearchString(searchTerm);
    filterByClaimNumber(searchTerm, activeDescriptions);
  };

  const transactionTypesHandler = (element) => {
    setActiveDescriptions(element);
    filterByTransactionType(element, searchString);
  };

  const resetFilterHandler = (e) => {
    e.preventDefault();
    setSearchString('');
    setActiveDescriptions([]);
    resetFilter();
  };
  const transactionTypeOptions = [
    { label: 'Contribution Amount', value: 'Contribution Amount' },
    { label: 'Payment Amount', value: 'Payment Amount' },
  ];

  return (
    <>
      {MasterPermissions.CheckPermission('View Transaction Details') && (
        <Col xs={12}>
          <Row className=" mb-4">
            <div className="myaccount-style-item col-xs-12 col-sm-4 col-md-4">
              <p className="m-0">Search</p>
              <TextInput
                parentClassName="mb-2 find-care-address"
                append={
                  <InputGroup.Text>
                    <SearchSVG.SearchSVG className="primary-text-color" />
                  </InputGroup.Text>
                }
                inputProps={{
                  type: 'text',
                  placeholder: 'Search txn date, claim #',
                  value: searchString,
                  onChange: claimSearchHandlr,
                  className: 'border-right-0',
                  autoFocus: true,
                }}
              />
            </div>

            <div className="myaccount-style-item col-xs-12 col-sm-4 col-md-4">
              <p className="m-0">Transaction Types</p>
              <AutoSuggestionSelectComponent
                placeholder="All"
                options={transactionTypeOptions}
                isMulti
                components={{ IndicatorSeparator: () => null }}
                value={activeDescriptions}
                onChange={transactionTypesHandler}
              />
            </div>
            <div className="myaccount-style-item col-xs-12 col-sm-4 col-md-4">
              <Form.Label className="myaccount_label">&nbsp;</Form.Label>
              <div style={{ display: 'flex', 'align-items': 'flex-end' }}>
                <p className="myaccount-style-item-text" style={{ flex: '1' }}>
                  <a href="" onClick={resetFilterHandler}>
                    Reset Filters
                  </a>
                </p>

                <Nav className="myaccount-style-item-text download-table">
                  {downloadtxns && (
                    <div className="d-flex ml-2">
                      <DownloadDropdown
                        data={
                          csvDetailedInfo?.length > 0
                            ? frameDataForCSV(csvDetailedInfo)
                            : []
                        }
                        label="Download"
                        fileName="AccountsReport"
                        showCSV={true}
                        //openPDF={ true }
                        tableHeader={TABLE_HEADER}
                      />

                      {shareTxns && (
                        <DownloadDropdown
                          data={
                            csvDetailedInfo?.length > 0
                              ? frameDataForCSV(csvDetailedInfo)
                              : []
                          }
                          label="Send"
                          fileName="AccountsReport"
                          showCSV={true}
                          showPDF={true}
                          tableHeader={TABLE_HEADER}
                          sendEmail={true}
                          emailPDFBody={AccountsPDFEmailBody}
                          emailCSVBody={AccountsCSVEmailBody}
                          successMessage="Account transactions list has been sent to your registered Email ID"
                          errorMessage="Account transactions list has not been sent.  Please try again after some time"
                          addressCC=""
                          addressBCC=""
                        />
                      )}
                    </div>
                  )}
                </Nav>
              </div>
            </div>
          </Row>
          <div className="toastify">
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </Col>
      )}
    </>
  );
};

export default AccountDetailsFilter;
